module.exports = __webpack_public_path__ + "img/telegram_v2.40fb7605.svg";